export enum ResponseTypeOptions {
    FreeText = 'Free Text',
    YesNo = 'Yes/No',
    SimpleCheck = 'Simple Check'
  }
  